import { API, authClient } from "../index";

// Get all clientes
export const getClientes = () => {
  return authClient().get(`${API}/cliente?getDisabled=true`);
};

// Get cliente by id
export const getClienteById = (id) => {
  return authClient().get(`${API}/cliente/${id}`);
};

// Delete cliente
export const deleteCliente = (id) => {
  return authClient().delete(`${API}/cliente/${id}`);
};

// Create cliente
export const postCliente = async (cliente) => {
  return authClient().post(`${API}/cliente`, cliente);
};

// Update cliente
export const updateCliente = async (id, cliente) => {
  return authClient().put(`${API}/cliente/${id}`, cliente);
};

// Change status cliente
export const changeStatusCliente = async (id, active) => {
  return authClient().put(`${API}/cliente/change-status/${id}`, { active });
};
